<section id="features" class="section">
  <div class="container pb-5">
    <div class="section-heading mb-6 text-center">
      <span class="rounded-pill shadow-box badge badge-info bold py-2 px-4"
        >DashCore features</span
      >
      <h2 class="mt-3">What DashCore can do for you</h2>
    </div>

    <div class="row gap-y text-center text-md-left">
      <div
        class="col-md-4 py-4 rounded shadow-hover"
        *ngFor="let element of elements"
      >
        <dc-feather
          [name]="element.icon"
          [iconClass]="'stroke-primary mb-3'"
        ></dc-feather>
        <h5 class="bold">{{ element.title }}</h5>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab dolores
          ea fugiat nesciunt quisquam. Assumenda dolore error nulla pariatur
          voluptatem?
        </p>
      </div>
    </div>
  </div>
</section>
